import GraphServer from './6-server';

export default GraphServer;
